export const MenuTopSkeleton = () => {
  return (
    <header className='sticky top-0 z-20 flex flex-row items-center justify-between bg-secondary pt-3 pb-3 md:pt-4 md:pb-4 px-4 md:px-6 lg:px-10 lg:relative'>
      <div className='flex flex-row items-center animate-pulse'>
        <div className='lg:hidden w-5 h-5 bg-tertiary rounded-sm' />
        <div className='hidden lg:block w-[180px] h-6 bg-tertiary rounded-sm' />
      </div>
      <div className='flex items-center gap-6 animate-pulse'>
        <div className='w-32 h-9 bg-tertiary rounded-sm' />
        <div className='hidden xs:block w-28 h-9 bg-tertiary rounded-3xl' />
      </div>
    </header>
  );
};
